const videosEn = [
  {
    id: 'raneem-azzam-mpc',
    student: 'Raneem Azzam',
    major: 'Math, Physics & Chemistry Teacher',
    youtubeId: 'Fqe1HpZOUSc',
  },
  {
    id: 'Ashraf-Abou-Ziki-mpc',
    student: 'Ashraf Abou Ziki',
    major: 'Physical Therapy',
    youtubeId: '-HzCW18dB0A',
  },
  {
    id: 'Nidal-Hassan-mpc',
    student: 'Dr. Nidal Hassan',
    major: 'Veterinary Surgery',
    youtubeId: 'OZQszPPiUKE',
  },
  {
    id: 'Nour-Mahmoud-mpc',
    student: 'Eng. Nour Mahmoud',
    major: 'Computer and Communication Engineer',
    youtubeId: 'OldIZ-aSPa4',
  },
  {
    id: 'Mira-Abou-Dargham-mpc',
    student: 'Dr. Mira Abou Dargham',
    major: 'Pharmacy',
    youtubeId: 'v6jK2hJV2rY',
  },
  {
    id: 'Rima-Bou-Karroum-mpc',
    student: 'Eng. Rima Bou Karroum',
    major: 'Agriculture Engineer',
    youtubeId: 'EBXFpcXGFwU',
  },
  {
    id: 'Hazar-Khattar-mpc',
    student: 'Hazar Khattar',
    major: 'Behavioural and special needs Therapy',
    youtubeId: 'UbtYV9cLtx4',
  },
  {
    id: 'Wida-Bou-Hadir-mpc',
    student: 'Wida Bou Hadir',
    major: 'Business Administration',
    youtubeId: 'LwDDdpyL6DY',
  },
  {
    id: 'Bilal-Nasr-mpc',
    student: 'Bilal Nasr',
    major: 'Interior Architecture',
    youtubeId: 'EWJfni4u8b8',
  },
  {
    id: 'Heba-Btadini-mpc',
    student: 'Heba Btadini',
    major: 'Nutrition & Dietetics',
    youtubeId: 'JlJNYD2GPhs',
  },
  {
    id: 'Ranim-Ghanem-mpc',
    student: 'Ranim Ghanem',
    major: 'Radio & Tv Film',
    youtubeId: 'tsbPd07xSB0',
  },
  {
    id: 'Hanadi-Rajeh-mpc',
    student: 'Hanadi Rajeh',
    major: 'Sport Education',
    youtubeId: 'ydsGRWZdZoo',
  },
  {
    id: 'Iman-Dbeissy-mpc',
    student: 'Eng. Iman Dbeissy',
    major: 'Architecture',
    youtubeId: 'MIkqG2zFxY8',
  },
  {
    id: 'Alaa-Ghanem-mpc',
    student: 'Alaa Ghanem',
    major: 'Finance & Economics',
    youtubeId: 'JteBHJQKxts',
  },
  {
    id: 'Ghada-Al-Hakim-mpc',
    student: 'Dr. Ghada Al Hakim',
    major: 'Social Work',
    youtubeId: 'Hc_btXqwu2Y',
  },
  {
    id: 'Reebal-Bourjes-mpc',
    student: 'Reebal Bourjes',
    major: 'Mechanical Engineering',
    youtubeId: 'oL2AztOfbhE',
  },
  {
    id: 'Rana-Haydar-mpc',
    student: 'Rana Haydar',
    major: 'Midwife',
    youtubeId: 'b0pa96rcjk8',
  },
  {
    id: 'Katia-Bouadi-mpc',
    student: 'Katia Bouadi',
    major: 'Speech Therapy',
    youtubeId: 'yL-_AwtAnVA',
  },
  {
    id: 'carole-abou-chacra-legal',
    student: 'Carole Abou Chacra',
    major: 'Legal Attorney',
    youtubeId: 'JL2IawYYx50',
  },
  {
    id: 'celine-melhem-ot',
    student: 'Celine Melhem',
    major: 'Occupational Therapist',
    youtubeId: 'MNewCyqIFPk',
  },
  {
    id: 'dr-rodaina-kordab-pediatrician',
    student: 'Dr Rodaina Kordab',
    major: 'Pediatrician',
    youtubeId: 'Conar80T6KU',
  },
  {
    id: 'dr-rola-salah-hassan-dentist',
    student: 'Dr Rola Salah Hassan',
    major: 'Dentist',
    youtubeId: 'e3wMoT5_MUs',
  },
  {
    id: 'sahar-al-chami-nursing',
    student: 'Sahar Al Chami',
    major: 'Nursing Clinical Instructor',
    youtubeId: 'iSywUShHpok',
  },
  {
    id: 'dr-joelle-khoury-sawma-psychology',
    student: 'Dr Joelle Khoury Sawma',
    major: 'Clinical Psychology and Psychotherapist',
    youtubeId: 'g8S2tD4BcEY',
  },
  {
    id: 'tamara-hatoum-ai-robotics',
    student: 'Tamara Hatoum',
    major: 'Robotics and AI Trainer',
    youtubeId: 'F5Z_k1aIHG4',
  },
];

export default videosEn;
